module.exports = __webpack_public_path__ + "static/images/biffy_ufg_win.9072f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biffy_ufg_win.jpg
// module id = gj2+
// module chunks = 1